import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  role: "button",
  class: "ctapdb1 mp img-fluid",
  width: "199",
  height: "40",
  viewBox: "0 0 199 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = ["font-size"]
const _hoisted_3 = {
  role: "button",
  class: "ctapdb1 mp img-fluid",
  width: "199",
  height: "40",
  viewBox: "0 0 199 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_4 = ["font-size"]
const _hoisted_5 = {
  role: "button",
  class: "ctapdb1",
  width: "199",
  height: "40",
  viewBox: "0 0 199 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_6 = ["font-size"]
const _hoisted_7 = ["data-bs-title"]
const _hoisted_8 = {
  role: "button",
  class: "ctapdb1",
  width: "199",
  height: "40",
  viewBox: "0 0 199 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_9 = ["font-size"]

import { onMounted, ref } from 'vue';
import { promoBarStore } from '@/store/userPromoBarStore';


export default /*@__PURE__*/_defineComponent({
  __name: 'MainDarkLandingBarTop',
  setup(__props) {

const promobar = promoBarStore();
const show = ref(true);
const mainlandingbartopf = ref();
let vh = ref(0);

onMounted(
	async () => {
		fixedMenu();
	});

const fixedMenu = async () => {
	vh.value = window.innerHeight / 2;
	let offset = 66;
	document.addEventListener('scroll', function() {
		setTimeout(function() {
			var timeoutId = null;
			if (timeoutId) clearTimeout(timeoutId);
			timeoutId = setTimeout(fixedBar, 30);
		});
	});

	async function fixedBar() {
		// await nextTick();
		setTimeout(() => {
			if (window.scrollY > vh.value + offset) {
				if (mainlandingbartopf.value) mainlandingbartopf.value.style.top = offset + "px";
			} else if (window.scrollY < 10 /*offset + vh.value*/ ) {
				if (mainlandingbartopf.value) mainlandingbartopf.value.style.top = "0px";
			}
		}, 30);
	}
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (show.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "mainlandingbartop d-flex d-justify-content-center align-items-center text-center w-100",
        ref_key: "mainlandingbartopf",
        ref: mainlandingbartopf
      }, [
        (_unref(promobar).cta == 3 || !_unref(promobar).cta)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              onClick: _ctx.$scrollToTop,
              to: "/t/scontact",
              class: "tt-dropdown-item"
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock("svg", _hoisted_1, [
                  _cache[0] || (_cache[0] = _createElementVNode("rect", {
                    width: "199",
                    height: "40",
                    rx: "20",
                    fill: "#75AE3D"
                  }, null, -1)),
                  _createElementVNode("text", {
                    class: "ctapdb",
                    x: "98.5",
                    y: "21.5",
                    "font-size": _ctx.$t('landinglearning.cta1fontsize', '16'),
                    "dominant-baseline": "middle",
                    "text-anchor": "middle"
                  }, _toDisplayString(_ctx.$t('promolandingbar.text1', 'Book Executive Call')), 9, _hoisted_2)
                ]))
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true),
        (_unref(promobar).cta == 2 || !_unref(promobar).cta)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 1,
              onClick: _ctx.$scrollToTop,
              to: "/members/subscriptions",
              class: "tt-dropdown-item"
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock("svg", _hoisted_3, [
                  _cache[1] || (_cache[1] = _createElementVNode("rect", {
                    width: "199",
                    height: "40",
                    rx: "20",
                    fill: "#75AE3D"
                  }, null, -1)),
                  _createElementVNode("text", {
                    class: "ctapdb",
                    x: "98.5",
                    y: "21.5",
                    "font-size": _ctx.$t('landinglearning.cta1fontsize', '16'),
                    "dominant-baseline": "middle",
                    "text-anchor": "middle"
                  }, _toDisplayString(_ctx.$t('promolandingbar.text2', 'Start Trial')), 9, _hoisted_4)
                ]))
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true),
        (_unref(promobar).cta == 1)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 2,
              onClick: _ctx.$scrollToTop,
              to: "/g/1",
              id: "game-btn",
              "aria-current": "page",
              class: "d-none d-lg-block text-nowrap",
              "data-bs-html": "true",
              "data-bs-toggle": "tooltip",
              "data-bs-placement": "bottom",
              "data-bs-custom-class": "custom-tooltip",
              "data-bs-title": `<div class='tooltip-body'>${ _ctx.$t('games.topmenutooltip', 'Play our game Land of Titans and learn by doing, not just watching') }</div>`
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock("svg", _hoisted_5, [
                  _cache[2] || (_cache[2] = _createElementVNode("rect", {
                    width: "199",
                    height: "40",
                    rx: "20",
                    fill: "#75AE3D"
                  }, null, -1)),
                  _createElementVNode("text", {
                    class: "ctapdb",
                    x: "98.5",
                    y: "21.5",
                    "font-size": _ctx.$t('landinglearning.cta1fontsize', '16'),
                    "dominant-baseline": "middle",
                    "text-anchor": "middle"
                  }, _toDisplayString(_ctx.$t('promolandingbar.text3', 'Play Now')), 9, _hoisted_6)
                ]))
              ]),
              _: 1
            }, 8, ["onClick", "data-bs-title"]))
          : _createCommentVNode("", true),
        (_unref(promobar).cta == 1)
          ? (_openBlock(), _createElementBlock("div", {
              key: 3,
              id: "game-btn",
              role: "button",
              "aria-current": "page",
              class: "d-lg-none text-nowrap",
              "data-bs-html": "true",
              "data-bs-toggle": "tooltip",
              "data-bs-placement": "bottom",
              "data-bs-custom-class": "custom-tooltip",
              "data-bs-title": `<div class='tooltip-body'>${ _ctx.$t('games.topmenutooltipm', 'Desktop version is availabe. Please, use your desktop computer') }</div>`
            }, [
              (_openBlock(), _createElementBlock("svg", _hoisted_8, [
                _cache[3] || (_cache[3] = _createElementVNode("rect", {
                  width: "199",
                  height: "40",
                  rx: "20",
                  fill: "#75AE3D"
                }, null, -1)),
                _createElementVNode("text", {
                  class: "ctapdb",
                  x: "98.5",
                  y: "21.5",
                  "font-size": _ctx.$t('landinglearning.cta1fontsize', '16'),
                  "dominant-baseline": "middle",
                  "text-anchor": "middle"
                }, _toDisplayString(_ctx.$t('promolandingbar.text3', 'Play Now')), 9, _hoisted_9)
              ]))
            ], 8, _hoisted_7))
          : _createCommentVNode("", true)
      ], 512))
    : _createCommentVNode("", true)
}
}

})